import {LineProcessor} from "./line-processor";
import {JsonToSong} from "./json-to-song";

export const searchIndexUtils = {
  /**
   * Normalizes text by converting to lowercase, removing diacritics, 
   * and replacing special characters
   */
  normalize: text => text ? text.toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/ł/g, 'l') 
    : '',
    
  /**
   * Processes a song file and converts it into searchable documents
   */
  explodeSongs: async (fileName, file) => {
    // Parse the chord text file
    const linesProcessed = new LineProcessor().parseChordsTxt(file);
    
    // Convert processed lines to song objects
    const songsJson = new JsonToSong().songsEnriched(linesProcessed);
    
    // Create searchable documents from the songs
    return songsJson.map((song, index) => ({
      id: `${fileName}-${index + 1}`,
      fileName,
      songNumber: index + 1,
      title: song.title === '000000' ? '' : song.title,
      lyrics: song.lines.filter(line => line.type === 'inline-lyrics' ||
        (line.type === 'text' && !/^\s*\[[^\]]*\]\s*$/.test(line.content)))
        .map(line => line.type === 'inline-lyrics' ? line.segments.map(segment => segment.text).join('') : line.content)
        .join('\n').trim(),
      metadata: [...(song.artists || []), ...(song.tags || [])].join(' '),
      previewLines: song.lines.filter(line => line.type !== 'text' || !/^\s*\[[^\]]*\]\s*$/.test(line.content))
        .map(line => ({type: line.type, text: line.type === 'chord'
          ? line.content.map(chord => `${chord.prefix}${chord.chord}${chord.suffix}`).join('') : line.content})),
      content: searchIndexUtils.extractSearchableContent(song.lines)
    }));
  },
  
  /**
   * Extracts searchable text content from song lines
   */
  extractSearchableContent: lines => {
    return lines
      .filter(line => line.type === 'text' && line.content.trim() !== '')
      .map(line => {
        // Check if line is a title tag
        const match = line.content.match(/^\s*\[((Title|Tag|Artist|Key|Notation):\s*(.*))\]\s*$/i);
        
        // For title tags, add a special prefix for higher relevance in search results
        return match && match[2]?.toLowerCase() === 'title' 
          ? `${match[3].trim()} || ` 
          : line.content;
      })
      .join('\n');
  }
};
